import React from 'react'
import { AnswerMapHeader, AnswerMapRow } from './'
import shortid from 'shortid'

export default function StudentAnswerMapPage({subtest, studentScores, answers, page, headerText}) {
  return (
    <div className="new-page incorrect-answer-map">
      <section className="page-header-horizontal">
        <h3 className="page-title">Incorrect Answer Map - {subtest.displayName}</h3>
        <h3 className="school-class-info">{headerText}</h3>
      </section>
      <table>
        <AnswerMapHeader 
          answers={answers}
          page={page}
        />
        {studentScores.map(studentScore => 
          <AnswerMapRow
            studentScore={studentScore}
            subtest={subtest}
            answers={answers}
            key={shortid.generate()}
            page={page}
          />
        )}
      </table>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentAnswerMap/StudentAnswerMapPage.js